import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 旧「系统设置」页已并入后台管理；此处仅做登录态跳转，不再使用前端共享密码。
 */
function Settings() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('settings_authed');
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }
    navigate('/admin', { replace: true });
  }, [navigate]);

  return (
    <div style={{ maxWidth: 360, margin: '40px auto', padding: 24, textAlign: 'center', color: '#666' }}>
      正在跳转到后台管理…
    </div>
  );
}

export default Settings;
